export const MASKED_INPUT_MASKS = {
  date: '##/##/####',
  cpf: '###.###.###-##',
};
